import { request } from "../../../apis";
import { getCurrency } from "../../../plugins/utils";
const CURRENCY = getCurrency();

export const getAgentStatus = () =>
  request("get", `/${CURRENCY}/agent/apply/status`, {}, true, false);

export const getAreaCodeList = () => request("get", `/country`, {}, true, false);

export const applyAgent = ({ params }) => request("put", `/${CURRENCY}/agent/apply`, params, true);
